import { Loader2 } from "lucide-react";

type AudioPlayerPlayButtonProps = {
  disabled?: boolean;
  isLoading?: boolean;
  isPlaying: boolean;
  onPlayPause: () => void;
};

/** Rounded triangle punched out of the design's filled play circle. */
function PlayGlyph() {
  return (
    <svg
      aria-hidden="true"
      className="size-full"
      fill="currentColor"
      viewBox="0 0 48 48"
    >
      <path d="M23.3096 16.8662C22.0143 15.7445 20 16.6644 20 18.3779V30.4072C20.0003 32.1205 22.0144 33.0406 23.3096 31.9189L30.2539 25.9043C31.1748 25.1068 31.1748 23.6784 30.2539 22.8809L23.3096 16.8662Z" />
    </svg>
  );
}

/** Pause bars drawn on the play circle's grid so both states share a weight. */
function PauseGlyph() {
  return (
    <svg
      aria-hidden="true"
      className="size-full"
      fill="currentColor"
      viewBox="0 0 48 48"
    >
      <rect height="15" rx="1.5" width="4" x="19" y="16.5" />
      <rect height="15" rx="1.5" width="4" x="25" y="16.5" />
    </svg>
  );
}

function AudioPlayerPlayButton({
  disabled = false,
  isLoading = false,
  isPlaying,
  onPlayPause,
}: AudioPlayerPlayButtonProps) {
  return (
    <button
      aria-label={isPlaying ? "Pause audio" : "Play audio"}
      className="flex size-8 shrink-0 items-center justify-center rounded-full border-2 border-transparent bg-new-beginnings-base text-white transition-colors hover:border-new-beginnings-base hover:bg-new-beginnings-tints-800 hover:text-new-beginnings-base focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-new-beginnings-base focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 sm:ml-2 sm:size-12"
      disabled={disabled}
      onClick={onPlayPause}
      type="button"
    >
      {isLoading ? (
        <Loader2
          aria-hidden="true"
          className="size-4 animate-spin motion-reduce:animate-none sm:size-6"
        />
      ) : isPlaying ? (
        <PauseGlyph />
      ) : (
        <PlayGlyph />
      )}
    </button>
  );
}

export { AudioPlayerPlayButton };
